<template>
    <el-dialog custom-class="new-dialog-class"  :title="title" :visible.sync="visible" @close="close" width="500px" :close-on-click-modal="false">
        <div class="dialog-box">
            <div class="dialog-block-box" >
                <el-form :model="secretData.form" :rules="rules" ref="form" size="mini" label-position="top">  
                    <el-form-item label="IP地址列表:" prop="ip_list">
                        <el-input v-model="secretData.form.ip_list" type="textarea" :rows="6" placeholder="请输入IP地址，多个IP地址之间用英文逗号(,)分隔

示例：192.168.1.1,192.168.1.2,10.0.0.1" size="mini" class="dialog-div-input">
                        </el-input>
                    <div class="c909399 fs12"><i class="el-icon-info mr2"></i><span>多个IP地址之间请用英文逗号(,)分隔，支持IPv4格式</span></div>  
                    </el-form-item>                   
                </el-form>
            </div> 
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import util from "../../util/util";
    export default {
        props: {
            title: {
                type: String,
                default: '查看密钥'
            },
            visible: {
                type: Boolean,
                default: false
            },
            loading:{
                type: Boolean,
                default: false,  
            },
            ip_list:{
                type: String,
                default: ''
            }
        },
        data(){
            return{
                secretData:{
                    form:{
                        ip_list:"",
                    }
                },
                rules: {
                    ip_list: [
                    { required: true, message: '请输入IP地址', trigger: 'blur' },
                    { validator: util.validateIPWhitelist, trigger:'blur' }
                    ]
                }
            }
        },
        mounted() {
            this.secretData.form.ip_list=this.ip_list
        },
        methods:{
            close(){
                this.secretData.form.ip_list=""
                this.$emit('close')
            },
            sure(){
                this.$refs.form.validate(valid => {
                    if(valid){
                        this.$emit('sure', this.secretData.form)
                    }
                })
            }
        }
    }
</script>